import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetArbetsorderUppdragCommand extends BasicCommand<SetArbetsorderUppdragCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    uppdragId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetArbetsorderUppdragCommand";
    constructor(init: (instance: SetArbetsorderUppdragCommand) => void) {
        super("SetArbetsorderUppdragCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
